import { InjectionToken } from '@angular/core';

export type LogContext = Record<string, unknown>;

export interface ILogger {
  debug(message: string, context?: LogContext): void;
  info(message: string, context?: LogContext): void;
  warn(message: string, context?: LogContext): void;
  error(message: string, context?: LogContext): void;
  exception(error: unknown, context?: LogContext): void;
}

const defaultLogger: ILogger = {
  debug: () => undefined,
  info: () => undefined,
  warn: () => undefined,
  error: () => undefined,
  exception: () => undefined
};

// DI safety net for tests/isolated modules that do not provide LOGGER_TOKEN.
// AppModule provides LOGGER_TOKEN via LoggerService at runtime.
export const LOGGER_TOKEN = new InjectionToken<ILogger>('LOGGER_TOKEN', {
  providedIn: 'root',
  factory: () => defaultLogger
});
